import React from 'react';
import { TabsList, TabsTrigger } from '../ui/tabs';

export interface TabConfig {
  value: string;
  label: string;
  shortLabel?: string;
  icon: React.ReactNode;
}

interface SettingsTabsProps {
  tabs: TabConfig[];
}

const SettingsTabs = ({ tabs }: SettingsTabsProps) => {
  return (
    <TabsList className="grid w-full grid-cols-3 sm:grid-cols-3">
      {tabs.map(tab => (
        <TabsTrigger
          key={tab.value}
          value={tab.value}
          className="flex items-center justify-center gap-1 sm:gap-2 px-2 sm:px-4"
        >
          {tab.icon}
          <span className="text-xs sm:text-sm hidden sm:inline">
            {tab.label}
          </span>
          {tab.shortLabel && (
            <span className="text-xs sm:hidden">{tab.shortLabel}</span>
          )}
          {!tab.shortLabel && (
            <span className="text-xs sm:hidden">{tab.label}</span>
          )}
        </TabsTrigger>
      ))}
    </TabsList>
  );
};

export default SettingsTabs;
